import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';

import { AccountCharityListComponent } from './account-charity-list.component';

@NgModule({
  declarations: [AccountCharityListComponent],
  imports: [CommonModule, TableModule, ButtonModule, RippleModule, InputTextModule],
})
export class AccountCharityListModule {}
